module.exports = __webpack_public_path__ + "img/LamdeiniLearning-258.40a5e1a4.jpg";